<template>
  <div class="fmCloud" @mousemove.prevent="selectItems"       @contextmenu.prevent="showMenu($event)">
    <div class="fixed-top" :style="`width:${$store.state.appRightWidth}px`">
      <TabList
        ref="tabList"
        :placeholder="$t('setPage.SearchSet')"
        curId="0"
        @setNav="setNav"
        @searchList="searchList"
      ></TabList>
      <div class="fc-second">
        <div class="add-box add-box1">
          <div class="btn-add">
            <fm-button
              @click="openAddGatherDialog"
              icon="icon-cloud-add"
              round
              size="medium"
              >{{ $t('share.newCollections') }}</fm-button
            >
          </div>
        </div>
      </div>
      <div class="file-type">
        <div class="search-result" v-if="shareParams.keywords == ''">
          <el-tooltip
            class="item r-tooltip"
            effect="dark"
            :content="$t('setPage.AllSet')"
            placement="top"
          >
            <span class="all" style="font-weight: 500" @click="resetRouter"
              >{{ $t('setPage.AllSet') }}</span
            >
          </el-tooltip>
          <div class="total">
            {{ total }}
          </div>
        </div>
        <div class="search-result" v-if="shareParams.keywords !== ''">
          <el-tooltip
            class="item r-tooltip"
            effect="dark"
            :content="$t('setPage.AllSet')"
            placement="top"
          >
            <span class="all" @click="resetRouter">{{ $t('setPage.AllSet') }}</span>
          </el-tooltip>
          <div class="r-search">
            <svg-btn icon-class="icon-file-direction" />
             <div class="r-search-tit">
              {{$utils.searchTitSlice(shareParams.keywords)}}
            </div>
          </div>
        </div>

        <div class="fileClass">
          <div class="multiple-operation" v-if="checkedShares.length > 0">
            <div @click="isCancelShare()">
              <svg-btn icon-class="icon-share3" />
              <span> {{ $t(`share.deleteCollection`) }}</span>
            </div>
          </div>
          <div class="screenBt" style="margin-right: 4px">
            <svg-btn class="screen" icon-class="icon-option" />
            <div class="screenBox">
              <div
                @click="changeSort(item.id)"
                v-for="item in screenList"
                :key="item.id"
                :class="{
                  curScreen: item.id == screenId || item.id1 == screenId
                }"
              >
                <svg-btn icon-class="icon-cloud-check" />
                <span>{{ item.name }}</span>
              </div>
            </div>
            <!-- 为了适配悬浮而创建的子类 -->
            <div class="lineTips"></div>
          </div>
          <span class="line"></span>
          <fm-button
            class="icon-refresh"
            @click="refresh"
            icon="icon-refresh"
            type="info"
            text
            size="small"
          ></fm-button>
        </div>
      </div>
    </div>
    <div
      class="file-content"
      v-infinite-scroll="getShareList"
      ref="scrollBox"
      infinite-scroll-distance="50"
      infinite-scroll-immediate="false"
      @scroll="scrollBoxFun()"
      v-loading="loading"
      @mousedown="handleMouseDown($event, -1)"
      @mouseup.prevent="endSelection"
    >
      <div class="tab-th" v-show="total != 0">
        <div class="selectAll">
          <div @click="allCheck == 2 ? cancelCheckedVal() : setCheckedVal()">
            <svg-btn
              :icon-class="
                allCheck == 2
                  ? 'icon-file-check'
                  : allCheck == 0
                  ? 'icon-file-uncheck-'+$store.state.theme
                  : 'icon-file-checks'
              "
            >
            </svg-btn>
          </div>
          <span>{{ $t('setPage.SetName') }}</span>
        </div>
        <!-- 项目数 表头-->
        <div class="lineup2" style="cursor: auto;">
          <span>{{$t('setPage.NumberEntries')}}</span>
        </div>
        <!-- 浏览 表头-->
        <div
          class="lineup4"
          @click="changeSort(screenId == 4 ? 5 : 4)"
        >
          <span>{{ $t('setPage.browse') }}</span>
          <img
            v-show="screenId == 4 || screenId == 5"
            :src="
              screenId == 4
                ? $utils.getPng('web4/icon_order_descending')
                : $utils.getPng('web4/icon_order_ascending')
            "
          />
        </div>

        <!-- 收藏 表头-->
        <div
          class="lineup4"
          @click="changeSort(screenId == 2 ? 3 : 2)"
        >
          <span>{{ $t('setPage.Collect') }}</span>
          <img
            v-show="screenId == 2 || screenId == 3"
            :src="
              screenId == 2
                ? $utils.getPng('web4/icon_order_descending')
                : $utils.getPng('web4/icon_order_ascending')
            "
          />
        </div>

        <!-- 分享时间 表头-->
        <div
          class="lineup3"
          @click="changeSort(screenId == 0 ? 1 : 0)"
        >
          <span>{{ $t('setPage.ShareTime') }}</span>
          <img
            v-show="screenId == 0 || screenId == 1"
            :src="
              screenId == 0
                ? $utils.getPng('web4/icon_order_descending')
                : $utils.getPng('web4/icon_order_ascending')
            "
          />
        </div>
      </div>
      <div class="file-list" v-if="shareList.length > 0">
        <div
          class="file-item-hover"
          v-for="(item, index) in shareList"
          :key="index"
          @mousedown="handleMouseDown($event, index)"
          @mouseenter="handleMouseenter($event, index)"
          @mouseleave="handleMouseleave($event, index)"
          @dblclick="open(item)"
          :class="[
            { hoverItem: item.isHover || checkedShares.indexOf(index) > -1 },
          ]"
        >
          <a-dropdown :trigger="dropdown" @visibleChange="visibleChange">
            <div class="file-item">
              <div class="lineup1">
                <div class="icon_checks" @dblclick.stop>
                  <svg-btn
                    class="icon_checks"
                    @click.prevent="chooseFile(index)"
                    :icon-class="
                      checkedShares.indexOf(index) > -1
                        ? 'icon-file-check'
                        : 'icon-file-uncheck-'+$store.state.theme
                    "
                  ></svg-btn>
                </div>
              <div class="openFoldername">
                <div class="file_icon">
                  <img class="icon" @error="onError($event, item)"
                        :src="item.ext_icon ? item.ext_icon : $utils.fileIcon(item.extension)"/>
                </div>
                <el-tooltip open-delay="1000" popper-class="item list-tooltip" effect="dark" :content="`${item.name}${item.extension?item.extension :''}`" placement="bottom">
                  <span class="name">{{ item.name }}{{ item.extension }}</span>
                </el-tooltip>
              </div>
              </div>
              <div @dblclick.stop class="tools-box" v-if="item.isHover || checkedShares.indexOf(index) > -1 || hoverIndex === index">
                <div class="itemFilesTools" v-show="checkedShares.length < 2">
                  <template>
                    <div
                      class="act"
                      @click="open(item)"
                    >
                      <el-tooltip
                        open-delay="1000"
                        popper-class="item list-tooltip"
                        effect="dark"
                        content="打开"
                        placement="bottom"
                      >
                        <svg-btn icon-class="icon-view" iconColor="iconColor2"></svg-btn>
                      </el-tooltip>
                    </div>
                    <div class="act" @click.stop="copyUrl(item)">
                      <el-tooltip open-delay="1000"
                        popper-class="item list-tooltip"
                        effect="dark"
                        content="复制"
                        placement="bottom"
                      >
                        <svg-btn icon-class="icon-share2"></svg-btn>
                      </el-tooltip>
                    </div>
                    <div class="act" @click.stop="openShareBox(item)">
                      <el-tooltip open-delay="1000"
                        popper-class="item list-tooltip"
                        effect="dark"
                        content="分享"
                        placement="bottom"
                      >
                        <svg-btn icon-class="icon-share1"></svg-btn>
                      </el-tooltip>
                    </div>
                    <div
                      class="act"
                      @click.stop="getGatherInfoList(item)"
                    >
                      <el-tooltip open-delay="1000"
                        popper-class="item list-tooltip"
                        effect="dark"
                        content="编辑"
                        placement="bottom"
                      >
                        <svg-btn icon-class="icon-share"></svg-btn>
                      </el-tooltip>
                    </div>
                    <div class="act">
                      <el-dropdown placement="bottom-start"
                        @visible-change="changeVisible($event, item)"
                        @command="(command) => handleCommand(command, item)"
                      >
                        <div>
                          <svg-btn icon-class="icon-cloud-more"></svg-btn>
                        </div>
                        <el-dropdown-menu
                          class="moreAct"
                          slot="dropdown"
                          :class="isOpen ? '' : 'isOpen1'"
                        >
                          <el-dropdown-item command="a"
                            ><span>{{$t(`setPage.Delete`)}}</span></el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </template>
                </div>
              </div>
              <div style="width: 36px;" v-else></div>
               <!-- 项目数 列表 -->
               <div class="lineup2">{{item.file_count}}</div>

               <!-- 浏览 列表 -->
              <div class="lineup4">{{item.view_num}}</div>

              <!-- 收藏 列表 -->
              <div class="lineup4">{{item.collect_num}}</div>

              <!-- 分享时间 列表 -->
              <div class="lineup3">{{item.create_time}}</div>
            </div>
            <template #overlay>
              <a-menu @contextmenu.prevent class="menu-a" :class="isOpen2 ? 'menu-b':''">
                <a-menu-item v-show="!isSelectMore"
                  @click="rightHandle(menu_item.id, item)"
                  v-for="menu_item in list"
                  class="me-item"
                  :key="menu_item.id"
                  >
                  <div class="abot" v-if="menu_item.id == 3">{{ $t(menu_item.name) }}</div>
                  <span v-else>{{ $t(menu_item.name) }}</span>
                </a-menu-item>
                <a-menu-item v-show="isSelectMore" @click="rightHandle(5, item)"  class="me-item"> 
                  {{ $t(`setPage.Delete`) }}
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
        <div
          v-show="showFlag == 1"
          class="selection-box"
          :style="{
            left: selectionBox.left + 'px',
            top: selectionBox.top + 'px',
            width: selectionBox.width + 'px',
            height: selectionBox.height + 'px',
          }"
        ></div>
        <div class="isOver" v-if="isLoading2" v-loading="isLoading2"></div>

        <div class="isOver" v-if="isOver">{{ $t('cloud.noMore') }}</div>
      </div>
      <div class="file-default" v-if="!loading && shareList.length == 0">
        <img :src="$utils.getPng('web4/file_default')" />
        <div class="search" v-if="shareParams.keywords==''">
          <span>{{ $t('setPage.NoCollection') }}</span> <span>{{ $t('setPage.TextOne') }}</span>
        </div>
        <div class="search" v-else>
          <span>{{ $t('setPage.NoToCollection') }}</span><span>{{ $t('setPage.TextTwo') }}</span>
        </div>
      </div>
    </div>
    <!-- 分享文件 -->
    <GatherDialog
      ref="gatherDialog"
      @addShareUrl="addShareUrl"
      @handleClose="isShowGatherDialog = false"
      @dialogEditGather="dialogEditGather"
      :boxType="boxType"
      :handleItem="handleItem"
      :gather_ids="gather_ids"
      :shareUrl="shareUrl"
      :gather_name="gather_name"
      :isShow="isShowGatherDialog"
      :auto_set="auto_set"
      :isSysCode="isSysCode"
      :pucode="pucode"
      :open_pucode="open_pucode"
    ></GatherDialog>
    <ShareDialog
      boxType="2"
      :shareUrl="shareUrl"
      :handleItem="handleItem"
      :isShow="isShowShareDialog"
      :incomeList="incomeList"
      @handleClose="isShowShareDialog = false"
    ></ShareDialog>
    <!-- 选择合集文件 -->
    <AddGather
      ref="addGather"
      :isShow="isShowAddGather"
      :gatherBoxType="gatherBoxType"
      @gatherSearch="gatherSearch"
      @handleClose="isShowAddGather = false"
      @openShareDialog="openShareDialog"
      @addGather="addGather"
    >
    </AddGather>
    <!-- 回收站提示 -->
    <RecycleTips
      @handleClose="isShowTipDialog = false"
      @doDel="cancelShare"
      :isShow="isShowTipDialog"
      title="提示"
      :isSet="true"
      :recycle_expire_day="recycle_expire_day"
      recycle_tit="合集"
    ></RecycleTips>
    <!-- 绑定手机1  实名认证2 验证码3-->
    <BindPhone
      :isShow="isShowBindPhone"
      :type="bindType"
      :time="time"
      @getPhoneCode="getPhoneCode"
      @bindPhone="bindPhone"
      @confirmNameAuth="realNameAuth"
      @handleClose="isShowBindPhone = false"
    ></BindPhone>
    <!-- 分享提示 -->
    <BaseDialog
      :isShow="isShowBaseDialog"
      :text="shareTips"
      :showCancel="false"
      @confirm="goAddGather"
      @handleClose="isShowBaseDialog = false"
      title="提示"
      >确 认</BaseDialog
    >
    <!-- 自定义右键菜单 -->
    <CustomContextMenu
        ref="customMenu"
        :visible="showContextMenu"
        :x="menuPosition.x"
        :y="menuPosition.y"
        :selected-item="selectedItem"
        @action="handleMenuAction"
        @close="closeMenu"
      />
    <div class="toTop-div" v-show="showTop" @click="scrollToTop">
      <svg-btn icon-class="icon-toTop" style="width: 24px;height: 24px;"></svg-btn>
    </div>
  </div>
</template>

<script>
import {
  compilaList,
} from "@/utils/apiList/set";
import {
  getExpireDay,
} from "@/utils/apiList/cloud"
import {
  addGather,
  editGather,
  gatherInfoList,
  shareSetInfo,
  cancelNewShare,
} from "@/utils/apiList/share";
import {
  bindPhoneSendCode,
  bindPhoneAPI,
  realNameAuth,
  getPopupStauts,
} from "@/utils/apiList/account";
import TabList from "./TabList/index.vue";
import GatherDialog from "@/components/Cloud/GatherDialog";
import AddGather from "@/components/Cloud/AddGather";
import ShareDialog from "@/components/Cloud/ShareDialog";
import BindPhone from "@/components/Cloud/BindPhone";
import BaseDialog from "@/components/Dialog/BaseDialog";
import RecycleTips from "@/components/Cloud/RecycleTips";
import CustomContextMenu from "@/components/CustomContextMenu/index.vue";
export default {
  components: {
    GatherDialog,
    TabList,
    AddGather,
    ShareDialog,
    BindPhone,
    BaseDialog,
    RecycleTips,
    CustomContextMenu,
  },
  data() {
    return {
      fileType: [
        { id: 0, name: "cloud.all" },
        { id: 1, name: "cloud.package" },
        { id: 2, name: "cloud.medium" },
        { id: 3, name: "cloud.document" },
        { id: 4, name: "cloud.picture" },
      ],
      fileTypeId: 0,
      screenList: [
        { id: 4, id1: 5, name: "按浏览量排序" },
        { id: 2, id1: 3, name: "按收藏量排序" },
        { id: 0, id1: 1, name: "按时间排序" },
      ],
      screenId: 0,
      isShowGatherDialog: false,
      isShowAddGather: false,
      shareList: [], //分享列表
      allCheck: 0,
      checkedShares: [], //已选的分享数据
      total: 0,
      loading: true,
      shareParams: {
        //查询分享列表参数
        view_num:"",//浏览量排序 大小排序1倒叙，0升序 默认1
        collect_num:"",//收藏量排序 大小排序1倒叙，0升序 默认1
        create_time:1,//创建时间排序 大小排序1倒叙，0升序 默认1
        limit: 60,
        keywords: "",
        page: 0,
        type: 1, //类型 1-正常 0-回收站
      },
      gather_ids: [],
      gather_name: "",
      boxType: false,
      handleItem: {}, //当前操作项
      gatherBoxType: 1, // 1选择 2编辑
      isOver: false,
      showTop: false,
      shareUrl: "",
      cancelParams: [],
      isShowShareDialog: false,
      isShowBindPhone: false,
      bindType: 1, //
      msgid: "", //验证码id
      isbindphone: "", //是否绑定手机号
      timerA: null,
      time: 60,
      isShowBaseDialog: false,
      shareTips:
        "为了共同维护良好的网络环境，每次分享的文件将会经过机器检测，请勿分享非法文件。",
      auto_set: 0, //是否自动填充
      isSysCode: 1, // 1 默认系统 生成  2自定义
      pucode: "",
      open_pucode:'',
      startX: 0,
      startY: 0,
      selectionBox: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
      },
      moveBox: {
        left: 0,
        top: 0,
      },
      mouseDownIsCheck: false,
      isLoading2: false,
      list: [
        { id: 1, name: "setPage.View" },
        { id: 2, name: "share.copyLink" },
        { id: 3, name: "share.viewLink" },
        { id: 4, name: "setPage.Edit" },
        { id: 5, name: "setPage.Delete"  },
      ],
      showFlag: 0,
      isSelecting: 0,
      isOpen: false,
      isOpen2: true,
      isSelectMore: false,
      dropdown: ['contextmenu'],
      phone_item: {
        phone: "",
        pcode: "",
      },
      incomeList:[],
      hoverIndex:'',//判断鼠标移入了哪个index
      isShowTipDialog: false,
      recycle_expire_day:'',
      showContextMenu: false,
      menuPosition: { x: 0, y: 0 },
      selectedItem: [
        {
          id:2,
          name:'cloud.Refresh'
        },
      ]
    };
  },
  created() {
    let appRightWidth =
      document.getElementById("app-bottom-right")?.clientWidth;

    this.$store.commit("setAttr", {
      name: "appRightWidth",
      val: appRightWidth,
    });
    this.getShareList(1);
  },
  mounted() {
    this.$store.commit("setAttr", {
      name: "endSelectFuncallback",
      val: this.endSelectFun,
    });
  },
  watch: {
    checkedShares: {
      handler(newval, oldVal) {
        if (newval.length > 0 && newval.length < this.shareList.length) {
          this.allCheck = 1;
        } else if (newval.length == 0) {
          this.allCheck = 0;
        } else if (newval.length == this.shareList.length) {
          this.allCheck = 2;
        }
      },
      immediate: true,
    },
    pageValue(newVal) {
      if (newVal == 1) {
        this.cancelCheckedVal();
        this.scrollToTop();
      }
    },
  },
  methods: {
    showMenu(event){
      event.preventDefault(); // 阻止默认行为
      event.stopPropagation(); // 阻止事件冒泡
      
      const forbiddenSelectors = [
        '.file-item-hover',
        '.ant-dropdown',
        '.ant-dropdown-menu',
        '.ant-menu'
      ];
      const isForbidden = event.target.closest(forbiddenSelectors.join(','));
      if (isForbidden) {
        this.closeMenu();
        return;
      }
      this.cancelCheckedVal()
      // 获取菜单的实际尺寸
      const menuSize = this.$refs.customMenu.getMenuSize();
      const menuWidth = menuSize.width;
      const menuHeight = menuSize.height;

      // 获取视口尺寸
      const viewportWidth = document.documentElement.clientWidth;
      const viewportHeight = document.documentElement.clientHeight;

      // 动态调整菜单位置
      let x = event.clientX;
      let y = event.clientY-50;

      // 判断是否靠近窗口右侧
      if (x + menuWidth > viewportWidth) {
        x = event.clientX - menuWidth;
      }
      // 判断是否靠近窗口底部
      if (y + menuHeight > viewportHeight - 110) {
        y = event.clientY - 100;
      }
      // 设置菜单位置
      this.menuPosition = {
        x: x,
        y: y,
      };

      // 显示菜单
      this.showContextMenu = true;
    },
    closeMenu() {
      this.showContextMenu = false
    },
    handleMenuAction(action) {
      switch(action) {
        case 2:
          this.refresh()
          break
      }
    },
    //打开合集
    open(row){
      window.open(row.share_link,'_blank');
    },
    setNav(item) {
      this.$router.push({
        path: item.url,
      });
    },
    chageClass(id) {
      this.fileTypeId = id;
      this.shareParams.type = id;
      this.shareParams.page = 0;
      this.checkedShares = [];
      this.getShareList(1);
    },
    //排序
    changeSort(id) {
      this.screenId = id;
      this.checkedShares = [];
      switch (id) {
        case 0:
          this.shareParams.create_time = 1;
          this.shareParams.collect_num = "";
          this.shareParams.view_num = "";
          break;
        case 1:
          this.shareParams.create_time = 0;
          this.shareParams.collect_num = "";
          this.shareParams.view_num = "";
          break;
        case 2:
          this.shareParams.collect_num = 1;
          this.shareParams.create_time = "";
          this.shareParams.view_num = "";
          break;
        case 3:
          this.shareParams.collect_num = 0;
          this.shareParams.create_time = "";
          this.shareParams.view_num = "";
          break;
        case 4:
          this.shareParams.view_num = 1;
          this.shareParams.create_time = "";
          this.shareParams.collect_num = "";
          break;
        case 5:
          this.shareParams.view_num = 0;
          this.shareParams.create_time = "";
          this.shareParams.collect_num = "";
          break;
        default:
          break;
      }
      this.shareParams.page = 0;
      this.getShareList(1);
    },
    //搜索
    searchList(value) {
      this.shareParams.keywords = value;
      this.checkedShares = [];
      this.getShareList(1);
    },
    getShareList: _.debounce(
      function (type = 0) {
        if (type == 1) {
          this.shareParams.page = 0;
          this.isLoading2 = false;
          this.loading = true;
        } else {
          if (this.isOver) return;
          this.isLoading2 = true;
          this.loading = false;
        }
        this.isOver = false;
        this.shareParams.page += 1;
        compilaList(this.shareParams)
          .then((res) => {
            if (res.status == "1") {
              this.loading = false;
              this.isLoading2 = false;
              this.total = res.data.total;
              if (res.data.list.length < this.shareParams.limit)
                this.isOver = true;
                res.data.list.forEach((item, index) => {
                  item.isHover = false;
                });
              if (this.shareParams.page == 1) {
                this.shareList = res.data.list;
              } else {
                this.shareList = this.shareList.concat(res.data.list);
              }
              if (
                this.checkedShares.length > 0 &&
                this.checkedShares.length < this.shareList.length
              ) {
                this.allCheck = 1;
              } else if (this.checkedShares.length == 0) {
                this.allCheck = 0;
              } else if (this.checkedShares.length == this.shareList.length) {
                this.allCheck = 2;
              }
              this.dropdown = ['contextmenu']
            }
          })
          .catch((err) => {});
      },
      300,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    openMessage(row) {
      const h = this.$createElement;
      this.$message({
        type: "success",
        duration: 3000,
        message: h(
          "div",
          {
            style:
              "padding-right:20px display: flex;align-items: center;color:#00B42A",
          },
          [
            h("span", null, "合集已放入回收站 "),
            h(
              "span",
              {
                style:
                  "position:absolute;top:50%;transform: translate(0, -50%);right: 15px;cursor:pointer",
                on: {
                  click: () => {
                    this.toRestore(row);
                  },
                },
              },
              "撤销"
            ),
          ]
        ),
      });
    },
    //下拉框出现/隐藏时触发
    changeVisible(e, item) {
      item.isHover = e;
    },
    //更多 操作 a重命名 b取消分享
    handleCommand(command, item) {
      this.handleItem = item;
      this.isCancelShare(command);
    },
    // 单个点击选中
    chooseShare(index) {
      // 点击文件选中
      var exist = this.checkedShares.indexOf(index);
      if (exist == -1) {
        this.checkedShares.push(index);
      } else {
        this.checkedShares.splice(exist, 1);
      }
    },
    // 全选
    setCheckedVal() {
      // 点击文件选中
      this.checkedShares = [];
      var tmpfiles = this.shareList;
      for (var i = 0, len = tmpfiles.length; i < len; i++) {
        this.checkedShares.push(i);
      }
      this.allCheck = 1;
    },
    // 取消全选
    cancelCheckedVal() {
      this.allCheck = 0;
      this.checkedShares = [];
    },
    //获取回收站过期时间
    getExpireDay() {
      getExpireDay().then((res) => {
        if (res.status == "1") {
          this.recycle_expire_day = res.data.recycle_expire_day;
          this.isShowTipDialog = true;
        } else {
          this.$toast(res.msg, 2);
        }
      });
    },
    // 获取选中的文件的id
    getSelFileIds() {
      var ids = [];
      this.checkedShares.map((item) => {
        ids.push(this.shareList[item].id)
      });
      return this.$utils.arrFilter(ids);
    },
    isCancelShare(row) {
      //多选
      if (this.checkedShares.length > 0) {
        this.cancelParams = this.getSelFileIds();
        //如果选中了某一项，且悬浮了其他项进行取消操作
        if(row){
          this.cancelParams = [this.handleItem.id]
        }else{
          this.cancelParams = this.getSelFileIds();
        }
      }else{
        this.cancelParams = [this.handleItem.id]
      }
      this.getExpireDay();
    },
    //删除合集
    cancelShare() {
      cancelNewShare({
        g_ids:this.cancelParams.join(','),
        type:0, //0-删除合集 1-恢复合集 2-彻底删除
      })
        .then((res) => {
          if (res.status == "1") {
            this.isShowTipDialog = false;
            // this.$toast(res.msg, 1);
            this.openMessage(this.cancelParams.join(','));
            this.checkedShares = [];
            this.getShareList(1);
          } else {
            this.$toast(res.msg, 2);
          }
        })
        .catch((err) => {});
    },
    //恢复合集
    toRestore: _.debounce(
      function (row) {
      cancelNewShare({
        g_ids:row,
        type:1, //0-删除合集 1-恢复合集 2-彻底删除
      }).then((res) => {
          if (res.status == "1") {
            this.checkedShares = [];
            this.getShareList(1);
            this.$message.closeAll(); //关闭message弹窗
          } else {
            this.$toast(res.msg, 2);
          }
        });
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //创建合集判断
    openAddGatherDialog() {
      this.handleItem = {};
      //是否绑定手机号 实名 第一次分享
      if (this.$store.state.userInfo.phone == "") {
        this.bindType = 1;
        this.isShowBindPhone = true;
        return;
      }
      // if(this.$store.state.userInfo.user_id_card_status == '0'){
      //   this.bindType=2
      //   this.isShowBindPhone=true
      //   return
      // }
      getPopupStauts({ popup_id: 100 }).then((res) => {
        if (res.status == "1") {
          if (res.data.is_open == "1") {
            this.isShowBaseDialog = true;
          } else {
            this.goAddGather();
          }
        }
      });
    },
    //获取是否自动填充 和 取件码选择
    shareSetInfo() {
      // let file_id = this.handleItem.id ? this.handleItem.is_gather=='1' ? '0': this.handleItem.id : '0'
      let file_id = '0'
      shareSetInfo({ file_id: file_id}).then((res) => {
        if (res.status == "1") {
          this.auto_set = parseInt(res.data.gather_auto_set);
          this.isSysCode = res.data.gather_pucode == "" ? 1 : 2; //空就是系统的
          this.$refs.gatherDialog.pucode = res.data.gather_pucode;
          this.open_pucode = res.data.gather_open_pucode
        }else{
          this.$toast(res.msg, 2);
        }
      });
    },
    //打开创建合集弹框
    goAddGather() {
      this.isShowBaseDialog = false;
      this.$refs.addGather.reset();
      this.$refs.addGather.fileLoading = true;
      this.$refs.addGather.getFileList();
      this.isShowAddGather = true;
    },
    openShareDialog(gather_ids, gather_name) {
      this.shareSetInfo();
      if (this.handleItem.id) {
        //编辑
        let params = {
          file_ids: gather_ids.toString(),
          gather_id: this.handleItem.id,
          gather_name:gather_name,
        };
        this.editGather(params);
      } else {
        //新增合集
        this.gather_name = gather_name;
        this.gather_ids = gather_ids;
        this.boxType = true;
        this.isShowGatherDialog = true;
      }
    },
    //新建合集
    addShareUrl(params) {
      addGather(params)
        .then((res) => {
          if (res.status == "1") {
            this.$toast(res.msg, 1);
            this.isShowAddGather = false;
            this.boxType = false;
            this.shareUrl = res.data.gather_url;
            this.handleItem = {
              name: res.data.gather_name,
              id: res.data.gather_id,
              good_count: res.data.good_count,
            };
            this.$refs.addGather.reset();
            this.getShareList(1);
          } else {
            this.$toast(res.msg, 2);
          }
        })
        .catch((err) => {});
    },
    //分享弹框的 编辑合集路径
    dialogEditGather() {
      if (this.boxType) {
        this.isShowGatherDialog = false;
      } else {
        this.getGatherInfoList(this.handleItem);
      }
    },
    //修改合集
    editGather(params) {
      editGather(params).then((res) => {
        if (res.status == "1") {
            this.gather_name = res.data.gather_name;
            this.handleItem.name = res.data.gather_name;
            this.shareUrl = res.data.gather_url;
            this.isShowAddGather = false;
            this.isShowGatherDialog = true;
            this.boxType = false;
            this.getShareList(1);
            this.$toast(res.msg, 1);
        } else {
          this.$toast(res.msg, 2);
        }
      });
    },
    //获取合集内容
    getGatherInfoList(item) {
      if (this.$store.state.userInfo.phone == "") {
        this.bindType = 1;
        this.isShowBindPhone = true;
        return;
      }
      this.$refs.addGather.reset()
      this.handleItem = item;
      gatherInfoList({ gather_id: item.id, limit: 1000, page: 1 }).then(
        (res) => {
          if (res.status == "1") {
            let kvlist = []; //用来存放组装后新的数组对象
            let one = {}; //添加的对象
            for (var i in res.data.gather_files) {
              one = res.data.gather_files[i];
              one["isSelect"] = true;
              kvlist.push(one);
            }
            this.$refs.addGather.allCheck2 = 2;
            this.$refs.addGather.editFileList = kvlist;
            this.$refs.addGather.gather_name = res.data.gather.gather_name;
            this.$refs.addGather.gatherBoxType = 2;
            this.isShowAddGather = true;
          } else {
            this.$toast(res.msg, 2);
          }
        }
      );
    },
    //复制链接
    copyUrl(item) {
      if (this.$store.state.userInfo.phone == "") {
        this.bindType = 1;
        this.isShowBindPhone = true;
        return;
      }
      let msg =
        item.good_count == 1 ? "复制链接及取件码成功" : "复制链接成功";
      this.$copyText(item.share_link).then(
        (e) => {
          this.$toast(msg, 1);
        },
        function (e) {}
      );
    },
    //分享 列表打开分享弹框
    openShareBox(item) {
      if (this.$store.state.userInfo.phone == "") {
        this.bindType = 1;
        this.isShowBindPhone = true;
        return;
      }
      this.handleItem = item;
      this.shareUrl = item.share_link;
      this.boxType = false;
      this.isShowGatherDialog = true;
    },
    openShareDialog1() { 
      shareSetInfo({ file_id: this.handleItem.id }).then((res) => {
          if (res.status == "1") {
            this.shareUrl = this.handleItem.share_link;
            this.boxType = '2';
            this.isShowShareDialog = true;
            this.incomeList = res.data.rebate_model;
          }else{
            this.$toast(res.msg,2)
          }
        });
    },
    
    scrollBoxFun() {
      var scrollEl = this.$refs.scrollBox;
      this.showTop = scrollEl.scrollTop > 50;
      let list = document.getElementsByClassName("el-tooltip__popper");
      let list1 = document.getElementsByClassName("el-dropdown-menu");
      if (list.length > 0) {
        list[list.length - 1].style.display = "none";
      }
      if(list1.length > 0){
        list1[list1.length - 1].style.display = "none";
      }
      //滚动关闭右键菜单
      if(this.showContextMenu){
        this.showContextMenu = false
      }
    },
    scrollToTop() {
      let scrollEl = this.$refs.scrollBox;
      scrollEl.scrollTop = 0;
    },
  
    getPhoneAly(captcha_verify) {
      return new Promise((resolve) => {
        bindPhoneSendCode({
          phone: this.phone_item.phone,
          pcode: this.phone_item.pcode,
          captcha_verify: captcha_verify || "",
        }).then((res) => {
          if (res.status == "1") {
            resolve({
              result: true,
              validate: true,
            });
            this.$toast(res.msg, 1);
            this.msgid = res.data.msgid;
            this.bindType = 3;
            this.timerA = setInterval(() => {
              this.minute();
            }, 1000);
          } else if (res.status == 90001) {
            resolve({
                  result: false,
                  validate: false
                })
              this.$toast(res.msg, 2);
            this.$AliCode.handleOpen(this.getPhoneAly);
          } else {
            resolve({
              result: true,
              validate: true,
            });
            this.$toast(res.msg, 2);
          }
        });
      });
    },
    //发送验证码
    getPhoneCode(phone, pcode) {
      this.phone_item = {
        phone,
        pcode,
      };
      // var reg_tel =
      //   /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      // if (!reg_tel.test(phone)) {
      //     this.$toast("请正确输入手机号", 3);
      //     return true
      // }
      this.getPhoneAly();
    },
    minute() {
      this.time = this.time - 1;
      if (this.time == 0) {
        this.time = 60;
        clearInterval(this.timerA);
      }
    },
    bindPhone(data) {
      let params = { msgid: this.msgid, ...data };
      bindPhoneAPI(params).then((res) => {
        if (res.status == "1") {
          this.isShowBindPhone = false;
          this.$store.commit("getuserVuex");
          this.$toast(res.msg, 1);
        } else {
          this.$toast(res.msg, 2);
        }
      });
    },
    //实名
    realNameAuth(data) {
      realNameAuth(data).then((res) => {
        if (res.status == "1") {
          this.isShowBindPhone = false;
          this.$store.commit("getuserVuex");
          this.$toast(res.msg, 1);
        } else {
          this.$toast(res.msg, 2);
        }
      });
    },
    handleMouseDown: _.debounce(
      function (event, index) {
        if(index == -1){
          this.checkedShares = []
        }
        this.selectionBox = {
          left: 0,
          top: 0,
          width: 0,
          height: 0,
        };

        this.startX = event.clientX;
        this.startY = event.clientY;

        const currentX = event.clientX;
        const currentY = event.clientY;
        this.moveBox = {
          left: 0,
          top: 0,
        };
        // 检查触发事件的元素是否是 file-item-hover 的父元素
        if (event.button == 0) {
          let arr = ['icon_checks','iconColor']
          if (!arr.includes(event.target.classList[0])) {
            //点击icon_checks 即左侧选中多选不触发handleMouseDown 只触发chooseFile
            // 执行你的 mousedown 逻辑
            this.selectItemOne(index);
            this.moveBox = {
              left: currentX,
              top: currentY - 56,
            };
          }
        } else if (event.button == 1) {
        } else if (event.button == 2) {
          // this.checkedShares = [];
          if(index == -1) return;
          var exist = this.checkedShares.indexOf(index);
          if (exist == -1) {
            this.checkedShares = [];
            this.checkedShares.push(index);
          } else {
            // this.checkedShares.splice(exist, 1);
          }
          if (this.checkedShares.length > 1) {
            this.isSelectMore = true;
          } else {
            this.isSelectMore = false;
          }
        }
      },
      100,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),

    handleMouseenter(event, index) {
      this.hoverIndex = index
    },
    handleMouseleave(event, index){
      this.hoverIndex = ''
    },
    chooseFile(index) {
      // 点击文件选中
      var exist = this.checkedShares.indexOf(index);
      if (exist == -1) {
        this.checkedShares.push(index);
      } else {
        this.checkedShares.splice(exist, 1);
      }
    },

    selectItemOne(index) {
      if (index == -1) {
        this.isSelecting = 1;
        return;
      }
      // 点击文件选中
      var exist = this.checkedShares.indexOf(index);
      if (exist == -1) {
        this.checkedShares = [];
        this.checkedShares.push(index);
        this.isSelecting = 1;
      } else {
        // this.checkedShares.splice(exist, 1);
      }
    },
    selectItems: _.debounce(
      function (event) {
        const currentX = event.clientX;
        const currentY = event.clientY;

        // 计算选择框的位置和大小
        const minX = Math.min(this.startX, currentX);
        const minY = Math.min(this.startY, currentY);
        const maxX = Math.max(this.startX, currentX);
        const maxY = Math.max(this.startY, currentY);
        this.selectionBox = {
          left: minX,
          top: minY - 56,
          width: maxX - minX,
          height: maxY - minY,
        };
        if (this.isSelecting == 1) {
          // 遍历可选择项，判断是否在选择框内并选中
          this.shareList.forEach((item, index) => {
            const itemElement = document.querySelector(
              `.file-item-hover:nth-child(${this.shareList.indexOf(item) + 1})`
            );
            const itemRect = itemElement.getBoundingClientRect();
            if (itemRect.top > minY - 56 && itemRect.bottom < maxY + 69) {
              if (!this.checkedShares.includes(index)) {
                this.checkedShares.push(index);
              }
              this.showFlag = 1;
            } else {
              const index = this.checkedShares.indexOf(index);
              if (index !== -1) {
                this.checkedShares.splice(index, 1);
              }
            }
          });
        }
      },
      0,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),

    endSelection() {
      this.showFlag = 0;
    },
    endSelectFun() {
      this.isSelecting = 0;
      this.checkStr = "";
      this.showFlag = 0;
      this.$store.commit("setAttr", {
        name: "showFlag",
        val: 0,
      });
      this.$store.commit("setAttr", {
        name: "check_str",
        val: "",
      });
    },
    resetRouter() {
      this.shareParams={
        //查询分享列表参数
        view_num:"",//浏览量排序 大小排序1倒叙，0升序 默认1
        collect_num:"",//收藏量排序 大小排序1倒叙，0升序 默认1
        create_time:1,//创建时间排序 大小排序1倒叙，0升序 默认1
        limit: 60,
        keywords: "",
        page: 0,
        type: 1, //类型 1-正常 0-回收站
      },
      this.screenId = 0
      this.checkedShares=[]
      this.fileTypeId=0
      this.$refs.tabList.keyword = "";
      this.getShareList(1);
    },
    refresh() {
      this.shareParams.page = 0;
      this.checkedShares = [];
      this.getShareList(1);
    },
    rightHandle(id, item) {
      this.visibleChange(false);
      switch (id) {
        case 1:
          this.open(item)
          break;
        case 2:
          this.copyUrl(item);
          break;
        case 3:
          this.openShareBox(item);
          break;
        case 4:
          this.getGatherInfoList(item);
          break;
        case 5:
          this.isCancelShare();
          break;
        default:
          break;
      }
    },
    visibleChange(e) {
      if(e){
        this.dropdown = ['contextmenu','click']
        this.isOpen = e;
        this.isOpen2 = true
      } else {
        this.isOpen2 = false
        this.dropdown = ['contextmenu']
      }
    },
    onError(e, item) {
      this.$set(item, "showPlay", false);
    },
  },
  computed: {
    pageValue() {
      return this.shareParams.page;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
